import { useMediaQuery } from 'react-responsive';

export const Breakpoints = {
  mobileSm: 420,
  mobileLg: 560,
  tabletSm: 768,
  tabletLg: 1024,
  laptopSm: 1280,
  laptopLg: 1440,
};

/**
 * - `mobileSm`: 420px
 * - `mobileLg`: 560px
 * - `tabletSm`: 768px
 * - `tabletLg`: 1024px
 * - `laptopSm`: 1280px
 * - `laptopLg`: 1440px
 */
export const useViewport = () => {
  const isMobileSm = useMediaQuery({
    query: `(max-width: ${Breakpoints.mobileSm}px)`,
  });
  const isMobileLg = useMediaQuery({
    query: `(min-width: ${Breakpoints.mobileSm + 1}px) and (max-width: ${
      Breakpoints.mobileLg
    }px)`,
  });
  const isTabletSm = useMediaQuery({
    query: `(min-width: ${Breakpoints.mobileLg + 1}px) and (max-width: ${
      Breakpoints.tabletSm
    }px)`,
  });
  const isTabletLg = useMediaQuery({
    query: `(min-width: ${Breakpoints.tabletSm + 1}px) and (max-width: ${
      Breakpoints.tabletLg
    }px)`,
  });
  const isLaptopSm = useMediaQuery({
    query: `(min-width: ${Breakpoints.tabletLg + 1}px) and (max-width: ${
      Breakpoints.laptopSm
    }px)`,
  });
  const isLaptopLg = useMediaQuery({
    query: `(min-width: ${Breakpoints.laptopSm + 1}px) and (max-width: ${
      Breakpoints.laptopLg
    }px)`,
  });

  const isMobile = isMobileSm || isMobileLg;
  const isTablet = isTabletSm || isTabletLg;
  const isLaptop = isLaptopSm || isLaptopLg;
  const isPortable = isMobile || isTablet;

  return {
    isMobileSm,
    isMobileLg,
    isTabletSm,
    isTabletLg,
    isLaptopSm,
    isLaptopLg,
    isMobile,
    isTablet,
    isLaptop,
    isPortable,
  };
};
